// frame: ZGZa7 @ ui/dogdisk-user.pen
// spec: docs/ui/user-page-flows.md §2.7 ZGZa7 页面-错误页(403)

import { ErrorPageView } from './_view'

export function ForbiddenPage() {
  return (
    <ErrorPageView
      frameId="ZGZa7"
      code="403"
      title="没有访问权限"
      desc="您没有权限访问此页面;若认为是误判,请联系管理员或返回首页。"
    />
  )
}
